import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { NodeFilterActionTypes, NodeFilterActions } from '../actions/node-filter.actions';


@Injectable()
export class NodeFilterEffects {
  private actions$ = inject(Actions);
  loadNodeFilters$ = createEffect(() => this.actions$.pipe(
    ofType(NodeFilterActionTypes.LoadNodeFilters),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
